import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import cellEditFactory from "react-bootstrap-table2-editor";
import { Row, Col } from "reactstrap";

const EnptKpiTable = ({ kpis, reportId }) => {
  const data = Array.isArray(kpis) ? kpis : kpis ? [kpis] : [];

  const columns = [
    { 
      dataField: "test_date", 
      text: "Test Date", 
      editable: false, 
      style: (cell, row) => row.report_id === reportId 
        ? { minWidth: "120px", backgroundColor: "yellow", fontWeight: "bold" } 
        : { minWidth: "120px" } 
    },
    { dataField: "enterprises_tested", text: "Enterprises Tested", editable: false, style: { minWidth: "120px" } },
    { dataField: "enterprises_recieved", text: "Enterprises Received", editable: false, style: { minWidth: "130px" } },
    { dataField: "enterprise_delivery_ratio", text: "Enterprise Dlv Ratio (%)", editable: false, style: { minWidth: "140px" }, formatter: (c) => c !== null ? `${(Number(c) * 100).toFixed(2)}%` : '' },
    { dataField: "messages_triggered", text: "Messages Triggered", editable: false, style: { minWidth: "130px" } },
    { dataField: "messages_recieved", text: "Messages Received", editable: false, style: { minWidth: "130px" } },
    { dataField: "message_delivery_ratio", text: "Message Dlv Ratio (%)", editable: false, style: { minWidth: "140px" }, formatter: (c) => c !== null ? `${(Number(c) * 100).toFixed(2)}%` : '' },
    { dataField: "message_recognizable_ratio", text: "Recognizable Ratio (%)", editable: false, style: { minWidth: "140px" }, formatter: (c) => c !== null ? `${(Number(c) * 100).toFixed(2)}%` : '' },
    { dataField: "template_spoofing", text: "Template Spoofing", editable: false, style: { minWidth: "120px" } },
    { dataField: "recieved_sms", text: "Received SMS", editable: false, style: { minWidth: "100px" } },
    { dataField: "sms_ratio", text: "SMS Ratio (%)", editable: false, style: { minWidth: "100px" }, formatter: (c) => c !== null ? `${(Number(c) * 100).toFixed(2)}%` : '' },
    { dataField: "simbox_onnet", text: "Simbox On-net", editable: false, style: { minWidth: "120px" } },
    { dataField: "nosimbox_onnet", text: "No Simbox On-net", editable: false, style: { minWidth: "120px" } },
    { dataField: "simbox_nationaloffnet", text: "Simbox Nat Off-net", editable: false, style: { minWidth: "130px" } },
    { dataField: "nosimbox_nationaloffnet", text: "No Simbox Nat Off-net", editable: false, style: { minWidth: "150px" } },
    { dataField: "international", text: "International", editable: false, style: { minWidth: "100px" } },
    { dataField: "bypass_ratio", text: "Bypass Ratio (%)", editable: false, style: { minWidth: "120px" }, formatter: (c) => c !== null ? `${(Number(c) * 100).toFixed(2)}%` : '' },
    { dataField: "other_channels", text: "Other Channels", editable: false, style: { minWidth: "120px" } },
    { dataField: "other_channel_ratio", text: "Other Channel Ratio (%)", editable: false, style: { minWidth: "140px" }, formatter: (c) => c !== null ? `${(Number(c) * 100).toFixed(2)}%` : '' },
    { dataField: "whatsapp", text: "WhatsApp", editable: false, style: { minWidth: "90px" } },
    { dataField: "telegram", text: "Telegram", editable: false, style: { minWidth: "90px" } },
    { dataField: "viber", text: "Viber", editable: false, style: { minWidth: "90px" } },
    { dataField: "rcs", text: "RCS", editable: false, style: { minWidth: "90px" } },
    { dataField: "text_to_speech", text: "Text-to-Speech", editable: false, style: { minWidth: "110px" } },
    { dataField: "flash_call", text: "Flash Call", editable: false, style: { minWidth: "90px" } },
    { dataField: "non_specified", text: "Other Non-Specified Channels", editable: false, style: { minWidth: "100px" } },
    { dataField: "bypass_otherchannel_ratio", text: "Bypass + Other Channel Ratio (%)", editable: false, style: { minWidth: "180px" }, formatter: (c) => c !== null ? `${(Number(c) * 100).toFixed(2)}%` : '' },
  ];

  return (
    <div className="table-responsive">
      {data.length > 0 ? (
        <BootstrapTable
          keyField="id"
          data={data}
          columns={columns}
          filter={filterFactory()}
          classes="table table-bordered"
          wrapperClasses="table-responsive scrollable table_shadow_div"
          cellEdit={cellEditFactory({
            mode: "dbclick",
            blurToSave: true,
            afterSaveCell: (oldValue, newValue, row, column) => {
              const parsedValue = Number(newValue);
              if (!isNaN(parsedValue)) {
                row[column.dataField] = parsedValue;
              } else {
                row[column.dataField] = oldValue;
              }
            }
          })}
        />
      ) : (
        <div className="text-center py-4">No KPI Data Available</div>
      )}
    </div>
  );
};

export default EnptKpiTable;
